import { render, staticRenderFns } from "./listForms.vue?vue&type=template&id=03489956&scoped=true"
import script from "./listForms.vue?vue&type=script&lang=js"
export * from "./listForms.vue?vue&type=script&lang=js"
import style0 from "./listForms.vue?vue&type=style&index=0&id=03489956&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03489956",
  null
  
)

export default component.exports